/* eslint-disable */
import * as Redux from 'redux';
import { message } from 'antd';
import userService, { IUserValidateOTP } from 'src/services/UserService';
import Utils from 'src/utils';
import * as actionTypes from '../constants';
import authService, { AuthLogIn, AuthReg, IChangePasswordParams, IConfirmNewPassword, KeycloakLoginResponse } from '../../services/AuthService';
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from '../../configs/AppConfig';
import { history } from '../store/index';
import VFDLoanService from 'src/services/VFDService';

const SignOutUser = () => async (dispatch: Redux.Dispatch<any>) => {
  dispatch({
    type: actionTypes.LOGOUT_PENDING,
  });

  await signOut();
  await localStorage.clear();
  await sessionStorage.clear();
  window.location.href = '/';

  dispatch({
    type: actionTypes.LOGOUT_SUCCESS,
  });
};

export const signOut = () => (dispatch: Redux.Dispatch<any>) => {
  dispatch(SignOutUser());
};

const RegisterUser = (data: AuthReg) => async (dispatch: Redux.Dispatch<any>) => {
  localStorage.removeItem('aton');
  dispatch({
    type: actionTypes.REGISTER_PENDING,
  });

  const phoneNumber = Utils.convertPhoneToISO(data.phoneNumber);

  await userService
    .createANewUser({
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      phoneNumber,
      registrationType: 'SELF',
    })
    .then((res) => {
      // Store userId from backend response for later use
      if (res && res.userId) {
        sessionStorage.setItem('userId', res.userId);
      }
      dispatch({
        type: actionTypes.REGISTER_SUCCESS,
        payload: res,
      });
      // Redirect to OTP page as before
      history.push(`/auth/verify?phoneNumber=${data.phoneNumber}&email=${data.email}`);
      window.location.reload();
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.REGISTER_FAILED,
        payload: err,
      });
    });
};

export const registerUser = (data: AuthReg) => (dispatch: Redux.Dispatch<any>) => {
  dispatch(RegisterUser(data));
};

const LoginUser = (data: AuthLogIn) => async (dispatch: Redux.Dispatch<any>) => {
  localStorage.removeItem('aton');
  dispatch({
    type: actionTypes.LOGIN_PENDING,
  });

  await authService
    .loginAccount(data)
    .then(async (response: any) => {
      const keycloakData: KeycloakLoginResponse = response.data;
      const jwtToken = keycloakData.data.accessToken;

      // Store Keycloak tokens
      localStorage.setItem(actionTypes.AUTH_TOKEN, jwtToken);
      localStorage.setItem('refresh_token', keycloakData.data.refreshToken);
      localStorage.setItem('token_expires_in', String(keycloakData.data.expiresIn));

      try {
        // Get and set VFD loan token
        const vfdResponse = await VFDLoanService.getLoanToken();
        localStorage.setItem('vfd_token', vfdResponse.data.data.access_token);
        dispatch({ type: actionTypes.GET_LOAN_TOKEN_SUCCESS, payload: vfdResponse.data });
      } catch (error) {
        // Continue even if VFD token fetch fails
      }

      try {
        const user = await userService.findUserByPhoneNumber({
          userId: Utils.convertPhoneToISO(data.email),
        });

        dispatch({
          type: actionTypes.LOGIN_SUCCESS,
          payload: user,
        });

        localStorage.setItem(actionTypes.AUTH_TOKEN_AGG_ID, user.userId);
        localStorage.setItem(
          actionTypes.AUTH_USER,
          JSON.stringify({ user, tokens: { accessToken: jwtToken, refreshToken: keycloakData.data.refreshToken } })
        );
        window.location.href = Utils.isUserKycSubmitted(user) ? `${APP_PREFIX_PATH}/home` : `${APP_PREFIX_PATH}/onboarding`;
      } catch (userErr: any) {
        dispatch({ type: actionTypes.LOGIN_FAILED, payload: userErr });
        localStorage.clear();
      }
    })
    .catch(async (err: any) => {
      dispatch({
        type: actionTypes.LOGIN_FAILED,
        payload: err,
      });

      localStorage.clear();
      sessionStorage.clear();
    });
};

export const loginUser = (data: AuthLogIn) => (dispatch: Redux.Dispatch<any>) => {
  dispatch(LoginUser(data));
};

const VerifyPhoneOTP = (data: IUserValidateOTP) => async (dispatch: Redux.Dispatch<any>) => {
  dispatch({
    type: actionTypes.VALIDATE_OTP_PENDING,
  });

  await userService
    .userValidateOTP(data)
    .then((response: any) => {
      sessionStorage.setItem(actionTypes.USER_ID, response.userId);
      dispatch({
        type: actionTypes.VALIDATE_OTP_SUCCESS,
        payload: response,
      });
      localStorage.removeItem('aton');
      message.success('Account successfully created. Check your email for instructions!');
      history.push('/auth/createPassword');
      window.location.reload();
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.VALIDATE_OTP_FAILED,
        payload: err,
      });
    });
};

export const validateOTP = (data: IUserValidateOTP) => (dispatch: Redux.Dispatch<any>) => {
  dispatch(VerifyPhoneOTP(data));
};

export const confirmUpdatePassword = (data: IConfirmNewPassword) => (dispatch: Redux.Dispatch<any>) => {
  dispatch({
    type: actionTypes.RESET_USER_PASSWORD_PENDING,
  });

  const { newPassword, confirmationCode, username } = data;

  authService
    .confirmResetPassword({ username, newPassword, confirmationCode })
    .then(() => {
      dispatch({
        type: actionTypes.RESET_USER_PASSWORD_SUCCESS,
      });
      message.success('Password Changed, you can now log in with your new password.');
      history.push('/auth/login');
      window.location.reload();
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.RESET_USER_PASSWORD_FAILED,
      });
      message.error(err.message);
    });
};

export const changePassword = (data: IChangePasswordParams) => (dispatch: Redux.Dispatch<any>) => {
  dispatch({
    type: actionTypes.RESET_USER_PASSWORD_PENDING,
  });

  const { newPassword, oldPassword } = data;

  const authUserString = localStorage.getItem(actionTypes.AUTH_USER);
  const authUser = authUserString ? JSON.parse(authUserString) : null;
  const email = authUser?.user?.phoneNumber || '';

  if (!email) {
    dispatch({ type: actionTypes.RESET_USER_PASSWORD_FAILED });
    message.error('User not found. Please log in again.');
    return;
  }

  authService
    .changePassword({ email, newPassword, oldPassword })
    .then(() => {
      dispatch({
        type: actionTypes.RESET_USER_PASSWORD_SUCCESS,
      });
      message.success('Password Changed, you can now log in with your new password.');
      dispatch(signOut());
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.RESET_USER_PASSWORD_FAILED,
      });
      message.error(err.message || 'Failed to change password');
    });
};
